import { ILeaveDetails } from "../types";

export const formatLeaveTypeLabel = (leave: Pick<ILeaveDetails, "type" | "against_compoff_date" | "compoff_against_date" | "compOffDate">): string => {
  if (leave.type?.toLowerCase().replace(/[^a-z]/g, "") !== "compoff") return leave.type;
  // The earned-on date is separate from the leave's start/end dates.
  const earnedDate = [leave.against_compoff_date, leave.compoff_against_date, leave.compOffDate]
    .find(value => value && !Number.isNaN(new Date(value).getTime()));
  if (!earnedDate) return leave.type;
  const date = new Date(earnedDate);
  const label = date.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  return `${leave.type} (${label})`;
};
